package com.anjuros.website.templates.template6.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template6.components.PrimaryButton
import com.anjuros.website.templates.template6.components.SectionTitle
import com.anjuros.website.templates.template6.modules.Template6FAQ
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.modules.getColor
import com.anjuros.website.templates.template6.modules.getColorOpacity
import com.anjuros.website.templates.template6.util.ResKey
import com.anjuros.website.templates.template6.util.Template6Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template6FAQSection(){
    Column(
        modifier = Modifier
            .id("faq")
            .fillMaxWidth()
            .padding(topBottom = 120.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SectionTitle(
            title = ResKey.TEMPLATE6_FAQ_TITLE,
            subtitle = ResKey.TEMPLATE6_FAQ_SUBTITLE
        )

        P(
            attrs = Modifier
                .fontSize(18.px)
                .padding(leftRight = 10.px)
                .color(rgb(110,110,110))
                .lineHeight(32.px)
                .maxWidth(720.px)
                .margin(
                    top = 20.px,
                    bottom = 60.px
                )
                .textAlign(TextAlign.Center)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_FAQ_DESCRIPTION))
        }

        val breakpoint = rememberBreakpoint()

        if(breakpoint>=Breakpoint.LG) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(70.percent)
                    .gap(40.px)
                    .alignItems(AlignItems.Start)
            ) {

                FAQCallCard(modifier = Modifier.fillMaxWidth(40.percent))

                FAQAccordion(modifier = Modifier.fillMaxWidth(60.percent))

            }
        } else {
            Column(
                modifier = Modifier
                    .fillMaxWidth(90.percent)
                    .gap(40.px)
                    .alignItems(AlignItems.Center),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {


                FAQAccordion(modifier = Modifier.fillMaxWidth(100.percent))
                FAQCallCard(modifier = Modifier.fillMaxWidth(100.percent))


            }
        }

    }
}
@Composable
private fun FAQCallCard(modifier: Modifier) {

    Column(
        modifier = modifier
            .backgroundColor(Template6Theme.Primary.getColor())
            .borderRadius(24.px)
            .padding(42.px)
    ) {

        Box(
            modifier = Modifier
                .size(78.px)
                .backgroundColor(Template6Theme.Secondary.rgb)

                .borderRadius(50.percent),
            contentAlignment = Alignment.Center
        ) {

            Image(
                modifier = Modifier.size(40.px),
                src = "template6_faq.svg",
                alt = "current selection"
            )

        }

        P(
            attrs = Modifier
                .fontSize(34.px)
                .fontWeight(FontWeight.Bold)
                .color(Colors.White)
                .margin(top = 30.px, bottom = 18.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_FAQ_CARD_TITLE))
        }

        P(
            attrs = Modifier
                .fontSize(17.px)
                .lineHeight(30.px)
                .color(rgb(225,225,225))
                .margin(bottom = 34.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_FAQ_CARD_DESCRIPTION))
        }



        PrimaryButton(
            text = "Call ${Template6Constants.CLIENTS_PHONE}",
            backgroundColor = Template6Theme.Secondary.rgb,
            path = "tel:${Template6Constants.CLIENTS_PHONE}"
        )

    }

}
@Composable
private fun FAQAccordion(modifier: Modifier) {

    Column(
        modifier = modifier
            .gap(18.px)
    ) {

        Template6FAQ.entries.forEach {  template6FAQ ->
            FAQItem(
                template6FAQ = template6FAQ
            )
        }
    }

}
@Composable
private fun FAQItem(
    template6FAQ: Template6FAQ
) {

    var expanded by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Colors.White)
            .borderRadius(18.px)
            .border(
                1.px,
                LineStyle.Solid,
                rgb(230,230,230)
            )
            .overflow(Overflow.Hidden)
    ) {

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(if(expanded) Template6Theme.OpacityPrimary.getColorOpacity() else Colors.Transparent)
                .padding(28.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    expanded = !expanded
                },
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            P(
                attrs = Modifier
                    .fontSize(21.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(Template6Theme.Primary.getColor())
                    .margin(0.px)
                    .toAttrs()
            ) {
                Text(LocalText(template6FAQ.question))
            }
            P(
                attrs = Modifier
                    .fontSize(21.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(Template6Theme.Primary.rgb)
                    .margin(0.px)
                    .toAttrs()
            ) {
                Text(if(expanded)"-" else "+")
            }


        }

        if (expanded) {

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(1.px)
                    .backgroundColor(rgb(235,235,235))
            )

            P(
                attrs = Modifier
                    .fontSize(17.px)
                    .lineHeight(30.px)
                    .color(rgb(105,105,105))
                    .padding(28.px)
                    .margin(0.px)
                    .toAttrs()
            ) {
                Text(LocalText(template6FAQ.answer))
            }

        }

    }

}

